import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/nettleworth-frontend/src/app/(charts)/calculators/net-worth-calculator/page.client.jsx");
